module.exports = "<div class=\"app\">\n    <!--\n    <div class=\"app-header\">\n        <img class=\"app-header-logo\" src=\"/assets/images/data-arts-rgb.png\">\n    </div>\n    -->\n\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main